import { CHART_SUPPORT_THRESHOLD } from 'common/constants/chart'
import { useCurrentCycleInfo } from 'modules/pond/api/selector'

/**
 * Custom hook: returns true when the current cycle started before
 * CHART_SUPPORT_THRESHOLD, meaning chart visualisation is not supported.
 */
export const useIsCycleBeforeThreshold = (): boolean => {
  const cycleInfo = useCurrentCycleInfo()
  if (!cycleInfo?.startDate) return false
  return cycleInfo.startDate < CHART_SUPPORT_THRESHOLD
}
